import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 16px 0 0;
`;

export const Step = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #515151;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  margin-top: 16px;
  color: #515151;
  font-weight: 500;
`;

export const Description = styled.p`
  margin-top: 16px;
  text-align: center;
  color: #515151;
`;

export const ChildrenContainer = styled.div`
  width: 100%;
  margin-top: 32px;
`;
